import { render, staticRenderFns } from "./ScoringPanel.vue?vue&type=template&id=a671ed4e&scoped=true"
import script from "./ScoringPanel.vue?vue&type=script&lang=js"
export * from "./ScoringPanel.vue?vue&type=script&lang=js"
import style0 from "./ScoringPanel.vue?vue&type=style&index=0&id=a671ed4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a671ed4e",
  null
  
)

export default component.exports